import HttpService from "./htttp.service";

class AttendanceService {
  endpoint = "attendance";

  getall = async (id) => {
    return await HttpService.get(`${this.endpoint}/report/${id}`);
  };

  create = async (payload) => {
    return await HttpService.post(`${this.endpoint}/mark`, payload);
  };

  remove = async (payload) => {
    return await HttpService.post(`${this.endpoint}/removeAttendance`, payload);
  };

  update = async (id, payload) => {
    return await HttpService.put(`${this.endpoint}/${id}`, payload);
  };

  delete = async (id) => {
    return await HttpService.delete(`${this.endpoint}/${id}`);
  };
}

export default new AttendanceService();
